import isEmpty from "lodash/isEmpty";
import { t } from "@/i18n-js/instance";
import { useDebouncedValue } from "@circle-react/hooks/utils/useDebouncedValue";
import { useListPosts } from "../hooks/useListPosts";
import type { Post } from "../types/post";
import { PostItem } from "./PostItem";
import { NeedHelpWidget } from "./common/NeedHelpWidget";
import { SkeletonLoader } from "./common/SkeletonLoader";

interface PostListProps {
  searchText: string;
  spaceId?: string | number;
}

export const PostList = ({ searchText, spaceId = "" }: PostListProps) => {
  const debouncedSearchText = useDebouncedValue(searchText, 500);
  const { isLoading, data } = useListPosts(spaceId, debouncedSearchText);
  const posts = data?.records || [];

  if (isLoading) {
    return <SkeletonLoader rows={5} />;
  }

  if (isEmpty(posts)) {
    return (
      <div className="px-6">
        <NeedHelpWidget
          helpText={t("support_widget.no_articles_found")}
          buttonText={t("support_widget.still_need_help")}
        />
      </div>
    );
  }

  return (
    <div className="overflow-auto">
      <div className="mt-1.5 flex flex-col justify-center">
        {posts.map((post: Post) => (
          <PostItem key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};
